class SessionsFieldset {
  constructor(container, options = {}) {
    this.container = container;
    this.eventStartsAt = container.dataset.eventStartsAt;
    this.eventEndsAt = container.dataset.eventEndsAt;

    this.options = Object.assign({ maxSlots: 200 }, options);

    this.modal = new WizardModal({ class: "admin-modal", focusInput: false });
    this.modal.addPage({ header: "Generate Appoinment Slots", body: this.modalBody() });

    var modalBody = this.modal.container[0];
    this.slotsStartTimeInput = modalBody.querySelector("[name=slots_start_time]");
    this.slotsEndTimeInput = modalBody.querySelector("[name=slots_end_time]");
    this.slotStartOffsetInput = modalBody.querySelector("[name=slot_start_offset]");
    this.slotLengthInput = modalBody.querySelector("[name=slot_length]");
    this.slotReplaceInput = modalBody.querySelector("[name=replace_existing]");

    // BEHAVIOUR

    // nested:added is a jQuery custom event from nested_insert.js, so only a jQuery handler hears it.
    jQuery(this.container).on("nested:added", ".fieldset.slot", this.handleSlotAdded.bind(this));

    var handleGenerateSlotLinkClick = this.handleGenerateSlotLinkClick.bind(this);
    this.container.addEventListener("click", (event) => {
      if (event.target.closest("[data-session-fieldset-behaviour=generate-slots]")) {
        handleGenerateSlotLinkClick(event);
      }
    });
    this.modal.container[0].addEventListener("input", this.handleModalInputChange.bind(this));
    jQuery(this.modal).on("complete", this.handleModalComplete.bind(this));
  }

  // EVENT HANDLERS

  handleSlotAdded(e, data) {
    // We only need to set values for manually added slots
    if (data && data.generatedSlot) {
      return;
    }

    var slot = e.target;

    this.autoPopulateSlotTimes(slot);
  }

  handleGenerateSlotLinkClick(e) {
    var track = e.target.closest(".fieldset.track");

    this.openModal(track);
  }

  handleModalInputChange() {
    this.validateModal();
  }

  handleModalComplete() {
    if (this.slotReplaceInput.checked) {
      this.removeExistingSlots();
    }

    this.generateSlots();
  }

  // HELPERS

  autoPopulateSlotTimes(slot) {
    var startTime, endTime;
    var duration = this.sessionDuration(slot);

    var previousSlot = this.previousVisibleSlot(slot);
    if (previousSlot) {
      startTime = previousSlot.querySelector(".end-time").value;
    } else {
      startTime = this.eventStartsAt;
    }

    if (!startTime) {
      return;
    }

    if (duration) {
      endTime = moment(startTime).add(duration, "minutes");

      if (endTime.isAfter(this.eventEndsAt)) {
        endTime = null;
      }
    }

    this.setSlotTimes(slot, startTime, endTime);
  }

  openModal(track) {
    this.track = track;

    this.resetModal();
    this.modal.show();
    this.validateModal();
  }

  resetModal() {
    this.setTimeInput(this.slotsStartTimeInput, this.eventStartsAt);
    this.setTimeInput(this.slotsEndTimeInput, this.eventEndsAt);
    this.slotStartOffsetInput.val(this.sessionDuration(this.track));
    this.slotLengthInput.val(this.sessionDuration(this.track));
    this.slotReplaceInput.prop("checked", false);
  }

  validateModal() {
    if (!this.slotsStartTimeInput.value) {
      this.modal.disableCompletion("Start Time Missing");
      return;
    }
    if (!this.slotsEndTimeInput.value) {
      this.modal.disableCompletion("End Time Missing");
      return;
    }

    if (!this.slotStartOffsetInput.value) {
      this.modal.disableCompletion("Slot Start Offset Missing");
      return;
    }
    if (this.slotStartOffsetInput.value < 1) {
      this.modal.disableCompletion("Slot Start Offset Must Be > 0");
      return;
    }

    if (!this.slotLengthInput.value) {
      this.modal.disableCompletion("Slot Length Missing");
      return;
    }
    if (this.slotLengthInput.value < 1) {
      this.modal.disableCompletion("Slot Length Must Be > 0");
      return;
    }

    if (this.numberOfSlots() > this.options.maxSlots) {
      this.modal.disableCompletion(`Too Many Slots. Can't generate more than ${this.options.maxSlots} slots.`);
      return;
    }

    this.modal.enableCompletion();
  }

  removeExistingSlots() {
    // nested_insert.js binds these through jQuery, so the click has to come from jQuery too.
    jQuery(this.track.querySelectorAll(".fieldset.slot [data-behaviour=nested-remove]")).trigger("click");
  }

  generateSlots() {
    var slotsStartAt = moment(this.slotsStartTimeInput.value);
    var slotsEndAt = moment(this.slotsEndTimeInput.value);

    var currentStartsAt = moment(slotsStartAt);
    while (true) {
      var currentEndsAt = moment(currentStartsAt).add(this.slotLengthInput.value, "minutes");

      if (currentEndsAt.isAfter(slotsEndAt)) {
        break;
      }

      this.addSlot(this.track, currentStartsAt, currentEndsAt);

      currentStartsAt = currentStartsAt.add(this.slotStartOffsetInput.value, "minutes");
    }
  }

  addSlot(track, startTime, endTime) {
    // The second argument reaches the nested:added handler as its `data`, which only jQuery's
    // trigger delivers.
    jQuery(track.querySelector("[data-behaviour=nested-insert]")).trigger("click", { generatedSlot: true });

    var slots = track.querySelectorAll(".fieldset.slot");

    this.setSlotTimes(slots[slots.length - 1], startTime, endTime);
  }

  setSlotTimes(slot, startTime, endTime) {
    if (startTime) {
      this.setTimeInput(slot.querySelector(".start-time"), startTime);
    }
    if (endTime) {
      this.setTimeInput(slot.querySelector(".end-time"), endTime);
    }
  }

  setTimeInput(el, time) {
    el.value = moment(time).format("YYYY-MM-DD HH:mm");
  }

  numberOfSlots() {
    var slotsStartAt = moment(this.slotsStartTimeInput.value);
    var slotsEndAt = moment(this.slotsEndTimeInput.value);

    var totalMinutes = moment.duration(slotsEndAt.diff(slotsStartAt)).as("minutes");
    var slotOffsetLength = parseInt(this.slotStartOffsetInput.value);

    return totalMinutes / slotOffsetLength;
  }

  // jQuery's `:visible` test: an element with no layout boxes is skipped.
  previousVisibleSlot(slot) {
    for (var sibling = slot.previousElementSibling; sibling; sibling = sibling.previousElementSibling) {
      if (!sibling.matches(".fieldset.slot")) {
        continue;
      }
      if (sibling.offsetWidth || sibling.offsetHeight || sibling.getClientRects().length) {
        return sibling;
      }
    }

    return null;
  }

  sessionDuration(el) {
    return el.closest(".fieldset.event-session").querySelector(".duration").value;
  }

  modalBody() {
    var body = document.createElement("div");
    body.className = "definition-list";
    body.innerHTML = window.SparkleConfig.adminHtml.sessionsFieldsetGenerateSlots;

    return body;
  }
}

window.SessionsFieldset = SessionsFieldset;
